
// export const apiurl = "http://localhost:5050";
export const apiurl = "https://api.suwasthi.in";
